import { useContext } from 'react';

import ThemeContext from '../_context';

const useThemeContext = () => useContext(ThemeContext);
export default useThemeContext;
